<template>
    <div class="test">
        <h2>openinstall测试</h2>
        <div class="btngroup">
            <span id="h5">跳转h5</span>
            <span id="origin">跳转原生</span>
        </div>
    </div>
</template>

<script>
import { importSdk } from "../utils/tools"
export default {
    name: 'test',
    mounted () {
        this.$nextTick(() => {
            importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
        })
    },
    methods: {
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            data.jump_info = {
                jump_url: 2,
                url: 'https://www.baidu.com',
                params: "matchId=488335",
                code: 9,
                jumptype: 1
            }
            data.yxPath = window.location.href;
            new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey: process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready: function () {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('h5');
                    var btn_2 = document.getElementById('origin');
                    btn_1.style.visibility = "visible";
                    btn_1.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                    btn_2.style.visibility = "visible";
                    btn_2.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        },
    }
}
</script>

<style lang="less" scoped>
    h2{
        margin: 20px auto;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
    }
    .btngroup{
        position: absolute;
        left: 10%;
        bottom: 200px;
        width: 80%;
        display: flex;
        justify-content: space-between;
        span{
            display: block;
            width: 40%;
            height: 40px;
            line-height: 40px;
            background-color: red;
            color: #fff;
            border-radius: 10px;
            font-size: 16px;
            font-weight: bold;
            text-align: center;
        }
    }
</style>
